import { Typography } from '@mui/material'
import React from 'react'
import { ThemeProvider } from '@mui/material/styles'
import { theme } from '../../styles/theme'

export const HeaderMedium = ({ textHeader }: { textHeader: string }) => {
  return (
    <ThemeProvider theme={theme}>
      <Typography variant="h2" component="h2">
        {textHeader}
      </Typography>
    </ThemeProvider>
  )
}
